/**
 * Injects a `<link rel="preload" as="fetch" crossorigin>` tag for the given
 * URL so the browser starts downloading it well before the 3D viewer mounts.
 * Cleans up on unmount to keep the head lean.
 */
import { useEffect } from "react";

export default function usePreloadUrls(urls = []) {
    useEffect(() => {
        const created = [];
        const seen = new Set();
        for (const u of urls) {
            if (!u || seen.has(u)) continue;
            seen.add(u);
            const link = document.createElement("link");
            link.rel = "preload";
            link.as = "fetch";
            link.crossOrigin = "anonymous";
            link.href = u;
            document.head.appendChild(link);
            created.push(link);
        }
        return () => {
            for (const l of created) {
                try { document.head.removeChild(l); } catch {}
            }
        };
    }, [urls.join("|")]);
}
